import { BiCollapseAlt } from 'react-icons/bi';
import './UnitSelector.css';
import { useUserStore } from '../../contexts/userStore';
import ModalComponent from '../Modal/ModalComponent';
import { UnitsTreeView } from '../UnitsTreeView/UnitsTreeView';
import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/auth';
import CondominioService from '../../services/CondominioService';

export function UnitSelector({
   unitId,
   scopedUnitId,
   parentId,
   setParentId,
   disabled,
   modalTitle,
   inputLabel,
   clientId = null,
   fetch = false,
   ...props
}) {
   const { user } = useAuth();
   const { condominiums } = useUserStore();

   const [units, setUnits] = useState([]);
   const [modalIsOpen, setModalIsOpen] = useState(false);
   const [modalState, setModalState] = useState();
   const [isLoading, setIsLoading] = useState(fetch);
   const [error, setError] = useState("");

   useEffect(() => {
      setError(props.error);
   }, [props.error]);

   function openUnitModal(unitId) {
      if (units?.length === 0) {
         console.error("No units available to select.");
         return;
      }
      setModalIsOpen(true);
      setModalState({ unitId });
   }

   async function fetchUnits() {
      if (!fetch) return;
      if (!clientId) {
         console.error("Client ID is required to fetch units.");
         setIsLoading(false);
         return;
      }

      setIsLoading(true);
      try {
         const response = await CondominioService.listClientCondominiosPaginated(1, "", clientId, { orderDirection: "ASC", collumnTitle: "name" }, false, 150);
         console.log(response);
         if (response?.data?.items) {
            setUnits(response.data.items);
         }
      } catch (error) {
         console.error("Erro ao buscar unidades:", error);
      } finally {
         setIsLoading(false);
      }
   }

   useEffect(() => {
      if (!fetch) {
         setUnits(condominiums);
      }
   }, [condominiums]);

   useEffect(() => {
      if (fetch) {
         fetchUnits();
      }
   }, [fetch, clientId]);

   function getButtonLabel(parentId) {
      const selectedUnit = units.find(unit => unit.id === `${parentId}`);
      if (selectedUnit?.name) {
         return selectedUnit.name;
      }

      if (isLoading) {
         return <small>Carregando unidades...</small>;
      }

      return <small>Selecione a unidade</small>;
   }

   return (
      <>
         {units.filter(unit => unit.organizationId === user.userData.selectedOrganizationId && !unit.isDeviceUnit && unit.id !== unitId).length >= 0 && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
               <label htmlFor="select-unit-button" style={{ textAlign: 'left', color: 'var(--textColor)', marginBottom: 5 }}>
                  {inputLabel ?? 'Pertence a'}
               </label>
               <button
                  type='button'
                  id="select-unit-button"
                  className={`btn-select-unit ${error ? 'border-red-500!' : ''}`}
                  disabled={disabled}
                  onClick={e => {
                     openUnitModal(parentId ? `${parentId}` : null);
                  }}
               >
                  <span>
                     {getButtonLabel(parentId)}
                  </span>
                  <BiCollapseAlt />
               </button>
               {error && (
                  <span className="error-message">
                     {error}
                  </span>
               )}
            </div>
         )}
         {
            modalIsOpen && (
               <ModalComponent
                  modalIsOpen={modalIsOpen}
                  modalText={modalTitle ?? "Selecione o parente"}
                  handleConfirm={() => {
                     if (props.type === 'cadastro' || modalState.unitId !== unitId) {
                        setParentId(modalState.unitId);
                     }
                     setModalIsOpen(false);
                  }}
                  handleCancel={() => { setModalIsOpen(false); }}
                  hideButtons={false}
               >
                  <div className="modal-levels-selector-content">
                     <UnitsTreeView
                        unitsArg={units}
                        showRoot={false}
                        scopedUnitId={scopedUnitId}
                        values={modalState.unitId ? [modalState.unitId] : []}
                        onChange={ids => {
                           setModalState(prev => ({ unitId: ids[0] }));
                        }}
                        singleCheck={true}
                     />
                  </div>
               </ModalComponent>
            )
         }
      </>
   );
}